import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import LandingPage from './pages/LandingPage';
import LoginPage from './pages/LoginPage';
import AuthCallback from './pages/AuthCallback';
import OnboardingFlow from './pages/OnboardingFlow';
import Dashboard from './pages/Dashboard';
import DemoDashboard from './pages/DemoDashboard';
import ProfilePage from './pages/ProfilePage';
import PlanPage from './pages/PlanPage';
import ChatPage from './pages/ChatPage';

function AppRouter() {
  const location = useLocation();
  
  // Check for session_id in URL hash synchronously during render
  if (location.hash && location.hash.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/demo" element={<DemoDashboard />} />
      <Route path="/onboarding" element={<OnboardingFlow />} />
      <Route path="/dashboard" element={<Navigate to="/plan" replace />} />
      <Route path="/profile" element={<ProfilePage />} />
      <Route path="/plan" element={<PlanPage />} />
      <Route path="/chat" element={<ChatPage />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <Router>
        <AppRouter />
      </Router>
      <Toaster position="bottom-right" />
    </div>
  );
}

export default App;
